import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  storeAccessToken(accessToken: string, isRemember: boolean) {
    // clean first, to avoid previous token is storing in local storage
    this.removeToken();
    if (isRemember) {
      localStorage.setItem('token', accessToken);
    } else {
      sessionStorage.setItem('token', accessToken);
    }
    localStorage.setItem('other_tab_login', 'tmp');
    localStorage.removeItem('other_tab_login');
  }

  getToken(): string {
    return localStorage.getItem('token') || sessionStorage.getItem('token');
  }
  getAnonymousToken(): string {
    return localStorage.getItem('approvalToken') || '';
  }
  removeToken(): void {
    localStorage.removeItem('token');
    sessionStorage.removeItem('token');
  }

  constructor() {}
}
